import React from 'react'

import styled from 'styled'

export default props => <styled.Paragraph tag="p" {...props} />
